import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'

import Application from './containers/application'
import SetRespondentContext from './containers/set-respondent-context'
import {unregister} from './registerServiceWorker'
import {configureClient, configureSecondaryClient} from './data/client'
import {configureStore} from './data/store'

import {Provider} from 'react-redux'
import {BrowserRouter} from 'react-router-dom'

import { PersistGate } from 'redux-persist/integration/react'

import {Route, Switch} from 'react-router-dom'
import {ApolloProvider} from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'

import './styles/main.scss'
import initReactFastclick from 'react-fastclick'
import Helmet from 'react-helmet'

initReactFastclick()

const {store, persistor} = configureStore()
export const client = configureClient()
configureSecondaryClient()

if (process.env.NODE_ENV === 'production') {
    const head = document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//rum-static.pingdom.net/pa-5b220f5f29ccc50006000295.js'
    head.appendChild(script);
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ApolloHooksProvider client={client}>
        <ApolloProvider client={client}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Switch>
              <Route path="/:participantId/invitation/:invitationHash" component={SetRespondentContext} />
              <Route path="/:languageCode/:surveyId" component={Application} />
              <Route path="/" component={() => (
                <section className="home row">
                  <Helmet>
                    <body className="home" />
                  </Helmet>
                  <div className="loading-indicator card">
                    <div className="card-body">No survey link provided: Please open survey from the link in your email</div>
                  </div>
                </section>
                )
              }
              />
            </Switch>
          </BrowserRouter>
        </ApolloProvider>
      </ApolloHooksProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// removing already registered webworkers
unregister()



// WEBPACK FOOTER //
// ./src/index.js